import React from 'react'

const HamburgerMenuIcon = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      style={{ marginRight: '.75rem', cursor: 'pointer', visibility: 'hidden' }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18.5C0 8.55888 8.05888 0.5 18 0.5C27.9411 0.5 36 8.55888 36 18.5C36 28.4411 27.9411 36.5 18 36.5C8.05888 36.5 0 28.4411 0 18.5Z"
        fill="#fff"
      />
      <rect opacity="0.06" y="0.5" width="36" height="36" rx="18" fill="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 13.5C9 12.6716 9.67157 12 10.5 12H25.5C26.3284 12 27 12.6716 27 13.5C27 14.3284 26.3284 15 25.5 15H10.5C9.67157 15 9 14.3284 9 13.5ZM9 18.5C9 17.6716 9.67157 17 10.5 17H25.5C26.3284 17 27 17.6716 27 18.5C27 19.3284 26.3284 20 25.5 20H10.5C9.67157 20 9 19.3284 9 18.5ZM10.5 22C9.67157 22 9 22.6716 9 23.5C9 24.3284 9.67157 25 10.5 25H25.5C26.3284 25 27 24.3284 27 23.5C27 22.6716 26.3284 22 25.5 22H10.5Z"
        fill="#121661"
      />
    </svg>
  )
}
export default HamburgerMenuIcon
